<template>
  <div>
    <van-popup v-model="show" closeable :lazy-render="false">
      <div class="top_tip">
        <a-icon type="desktop" style="color: #FFFFFF; align-self: flex-start; font-size: 18px;"/>
        <div>Please go to PC side to experience more funcons!</div>
      </div>
      <div class="content">
        <div class="canvasWrap" ref="canvasWrap">
          <canvas id="canvas" ref="canvas" height="550" width="550"></canvas>
        </div>
        <img :src="src" alt="" class="img" />
        <div class="controls">
          <img src="@/assets/designMobile/shangchuan.png" alt="" @click="createInput" />

          <img src="@/assets/designMobile/picture_1.png" alt="" @click="$refs.PodImg.show = true" />
          <img src="@/assets/designMobile/words.png" alt="" @click="addWord" />
          <img src="@/assets/designMobile/turn-left.png" alt="" @click="turn('left')" v-if="showControl" />
          <img src="@/assets/designMobile/turn-right.png" alt="" @click="turn('right')" v-if="showControl" />
        </div>
        <van-field
          v-if="showFontset"
          readonly
          clickable
          :value="font"
          :class="fontClass"
          label="Font"
          placeholder="Click change font"
          @click="showPicker = true"
        >
        </van-field>

        <div class="footer">
          <van-button @click="show = false">Close</van-button>
          <van-button @click="saveProduct" type="primary" v-if="is_3d ===1">Save</van-button>
          <van-button @click="preview" type="primary" v-else>Preview</van-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showPreview" closeable :lazy-render="false">
      <div class="content" style="height:9.46rem;padding-bottom:0">
        <img
          :src="img.img"
          alt=""
          v-for="(img, index) in showImg"
          :key="index"
          class="showImg"
          :style="{ zIndex: img.sort }"
        />
      </div>
      <div class="saveProduct">
        <van-button @click="saveProduct" type="primary">Save</van-button>
      </div>
    </van-popup>

    <input type="file" ref="input" style="display:none" />
    <van-popup v-model="showPicker" position="bottom">
      <van-picker class="fontSet" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false">
      </van-picker>
    </van-popup>
    <PodImg ref="PodImg" @change="imgChange" :selectPodImg="selectPodImg" />
  </div>
</template>

<script>
import * as InitCanvas from '3dcanvas_me'
// import OSS from 'ali-oss'
import * as cc from 'my-design-canvas/desf4fc'
import PodImg from './podImg'
import { mapState, mapMutations } from 'vuex'
import { saveDesign, addMaterial, getOssInfo, uploadImg } from '@/api/design'
import store from '@/store'
let canvas = null
// const config = {
//   region: 'oss-cn-hangzhou',
//   accessKeyId: 'LTAI4FhgyAC1YHzARr36VqK2',
//   accessKeySecret: 'XBi2htAiUCZn3bptjyU9ZEZDKRVaOy',
//   bucket: 'snb-bucket'
// }
// const client = new OSS(config)
export default {
  name: 'Design',
  data() {
    return {
      columns: [
        { text: "<span style='font-family:Do Hyeon'>Do Hyeon</span>", value: 'Do Hyeon', class: 'Do' },
        { text: "<span style='font-family:Fjalla One'>Fjalla One</span>", value: 'Fjalla One', class: 'Fj' },
        { text: "<span style='font-family:Hanalei Fill'>Hanalei Fill</span>", value: 'Hanalei Fill', class: 'Ha' },
        { text: "<span style='font-family:Indie Flower'>Indie Flower</span>", value: 'Indie Flower', class: 'In' },
        { text: "<span style='font-family:Kirang Haerang'>Kirang Haerang</span>", value: 'Kirang Haerang', class: 'Ki' }
      ],
      font: 'Do Hyeon',
      showPicker: false,
      fontClass: 'Do',
      showControl: false,
      showFontset: false,
      show: false,
      showPreview: false,
      src: '',
      previewImg: '',
      overLayImg: '',
      allShowImgs: [],
      activeColor: '',
      sizeId: '',
      productId: '',
      showImg: [],
      selectPodImg: [],
      is_3d: ''
    }
  },
  computed: {
    ...mapState({
      token: state => state.user.token
    })
  },
  methods: {
    ...mapMutations({
      setToPath: 'SET_TO_PATH'
    }),
    onConfirm(value, index) {
      const t = canvas.getActiveObject()
      t && t.set('fontFamily', this.columns[index].value)
      canvas.renderAll()
      this.font = this.columns[index].value
      this.fontClass = this.columns[index].class
      this.showPicker = false
    },
    imgChange({ src, code, id }) {
      if (this.selectPodImg.indexOf(id) === -1) {
        this.selectPodImg.push(id)
        // addMaterial({ oss_file_id: id }).then(res => {
        //   this.addImg(res.show_image_src, { material_code: res.code, selectable: type === 2 })
        // })
        this.addImg(src, { material_code: code })
      } else {
        const index = this.selectPodImg.indexOf(id)
        this.selectPodImg.splice(index, 1)
        const removeObj = canvas.item(index)
        canvas.remove(removeObj)
      }
    },
    turn(type) {
      const t = canvas.getActiveObject()
      t && t.rotate(type === 'left' ? t.angle - 45 : t.angle + 45).setCoords()
      canvas.renderAll()
    },
    resize() {
      const canvasWrap = this.$refs.canvasWrap
      const { width } = canvasWrap.getBoundingClientRect()
      var scale = width / 550
      var zoom = canvas.getZoom()
      // this.zoom = zoom
      zoom *= scale
      canvas.setDimensions({
        width: width,
        height: width
      })
      canvas.setViewportTransform([zoom, 0, 0, zoom, 0, 0])
    },
    saveProduct() {
      if (this.token) {
        saveDesign({
          basic_product_id: this.productId,
          color_id: this.activeColor,
          size_id: this.sizeId,
          view_id: 1,
          product_design: [{ view_id: 1, design_params: canvas.toJSON(['material_code']) }]
        }).then(() => {
          this.$router.push('/personal_center/productTemplate')
        })
      } else {
        this.setToPath('')
        this.$emit('change', true)
      }
    },
    preview() {
      this.showPreview = true
      this.createShowImg(this.activeColor)
    },
    async createShowImg(colorId) {
      const designImg = canvas.toDataURL({ multiplier: 3.27 })
      const imgs = this.allShowImgs.find(items => items.find(item => item.view_id === 1 && item.color_id === colorId))
      const canvasForResult = this.createCanvas()
      const canvasForMerge = this.createCanvas()
      const showImg = []
      for (let i = 0; i < imgs.length; i++) {
        const img = imgs[i]
        if (img.view_id === 0) {
          showImg.push({ img: img.image_src, sort: i === 0 ? -1 : 1 })
        } else {
          const { canvas_config, big_image_src, is_point, point_origin_config } = img
          await this.addImgForShowImg(big_image_src, {}, canvasForMerge)
          if (is_point === 1) {
            const tImg = await this.createSt(
              designImg,
              point_origin_config.map(item => ({
                x: (item.x * 1000) / 469,
                y: (item.y * 1000) / 469
              }))
            )
            await this.addImgForShowImg(tImg, { globalCompositeOperation: 'source-atop' }, canvasForMerge)
          } else {
            await this.addImgForShowImg(
              designImg,
              {
                ...canvas_config,
                globalCompositeOperation: 'source-atop',
                top: (canvas_config.top * 1000) / 469,
                left: (canvas_config.left * 1000) / 469,
                scaleX: canvas_config.scaleX * (1200 / 469),
                scaleY: canvas_config.scaleY * (1200 / 469)
              },
              canvasForMerge
            )
          }
          await this.addImgForShowImg(canvasForMerge.toDataURL(), {}, canvasForResult)
          canvasForMerge.clear()
        }
      }
      showImg.push({ img: canvasForResult.toDataURL(), sort: 0 })
      canvasForResult.clear()
      this.showImg = showImg
    },
    dataURLtoBlob(dataurl) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    createSt(base64, point) {
      const PrintAreas = {
        offset_x: '0.00000',
        offset_y: '0.00000',
        width: '2000.00000',
        height: '2000.00000'
      }
      return new Promise(resolve => {
        const canvas = document.createElement('canvas')
        canvas.height = 1000
        canvas.width = 1000
        const img = new Image()
        img.src = base64
        img.onload = () => {
          // eslint-disable-next-line no-new
          new InitCanvas(canvas, JSON.stringify(point), PrintAreas, img)
          resolve(canvas.toDataURL())
        }
      })
    },
    createCanvas() {
      const canvas = document.createElement('canvas')
      canvas.height = 1000
      canvas.width = 1000
      return new cc.StaticCanvas(canvas, {})
    },
    loadImg(url) {
      return new Promise(resolve => {
        const img = new Image()
        img.src = url
        img.onload = () => {
          resolve(img)
        }
        img.crossOrigin = 'anonymous'
      })
    },
    // 图片合成
    async addImgForShowImg(url, config, canvas) {
      const img = await this.loadImg(url)
      const imgInstance = new cc.Image(img, config)
      // 添加对象后, 如下图
      canvas.add(imgInstance)
      canvas.renderAll()
    },
    removeImg(value) {
      console.log(value)
      const objects = canvas.getObjects()
      console.log(objects)
    },
    // 图片加入canva
    addImg(url, config) {
      store.commit('SET_LOADING', true)
      cc.Image.fromURL(
        url,
        function(img) {
          const { height, width } = img
          const baseScale = height > width ? height : width
          img.scale(300 / baseScale)
          img.set({
            originX: 'center',
            originY: 'center',
            left: 275,
            top: 275
          })
          config && img.set(config)
          canvas.add(img)
          canvas.renderAll()
        },
        { crossOrigin: 'anonymous' }
      )
      store.commit('SET_LOADING', false)
    },
    randomString(len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    createInput() {
      const input = this.$refs.input
      input.click()
      input.onchange = e => {
        console.log(e)
        const file = e.target.files[0]
        const { name } = file
        getOssInfo().then(res => {
          const formData = new FormData()
          formData.append('accessid', res.data.accessid)
          formData.append('key', res.data.dir + this.randomString(10) + '.' + name.split('.')[1])
          formData.append('policy', res.data.policy)
          formData.append('OSSAccessKeyId', res.data.accessid)
          // formData.append('success_action_status', 200)
          formData.append('callback', res.data.callback)
          formData.append('signature', res.data.signature)
          // formData.append('g_object_name_type', 'random_name')
          formData.append('file', file)
          formData.append('name', name)
          uploadImg(formData).then(res => {
            addMaterial({ oss_file_id: res.data.id }).then(res => {
              console.log(res)
              this.addImg(res.data.show_image_src, { material_code: res.data.code })
            })
          })
        })
      }
    },
    addWord() {
      console.log('3333')
      const text = new cc.IText('TEXT', {
        left: 275,
        top: 275,
        fontSize: 50,
        width: 120,
        fontFamily: 'Do Hyeon',
        originX: 'center',
        originY: 'center',
        fixedWidth: 150
      })
      console.log(canvas)
      canvas.add(text)
    }
  },
  components: { PodImg },
  mounted() {
    canvas = new cc.Canvas(document.getElementById('canvas'), {
      preserveObjectStacking: true
    })
    canvas.on('object:removed', e => {
      const { target } = e
      if (target.type === 'image') {
        const { id } = target
        if (this.selectPodImg.indexOf(id) !== -1) {
          this.selectPodImg.splice(this.selectPodImg.indexOf(id), 1)
        }
      }
    })
    canvas.on('text:changed', function(opt) {
      var t1 = opt.target
      if (t1.width > t1.fixedWidth) {
        t1.fontSize *= t1.fixedWidth / (t1.width + 1)
        t1.width = t1.fixedWidth
      }
    })
    canvas.on('mouse:down', e => {
      const { target } = e
      if (target) {
        if (target.type === 'i-text') {
          this.showFontset = true
        } else {
          this.showFontset = false
        }
        this.showControl = true
      } else {
        this.showControl = false
        this.showFontset = false
      }
    })
  }
}
</script>

<style lang="less" scoped>
.top_tip {
  display: flex;
  padding: 10px;
  border-radius: 40px;
  transform: translateY(40px);
  width: 90%;
  margin-left: 5%;
  align-items: center;
  color: white;
  background: #FFBA2F;
  div {
    font-size: 14px;
    font-weight: 400;
    text-align: center;
  }
}
.saveProduct {
  padding: 10px;
  padding-bottom: 5px;
  box-sizing: border-box;
  text-align: right;
  font-size: 0;
}
.content {
  height: 100%;
  box-sizing: border-box;
  width: 325px;
  padding: 10px;
  padding-top: 50px;
  position: relative;

  .showImg {
    position: absolute;
    height: 305px;
    width: 305px;
  }
  .canvasWrap {
    background-image: url('../../assets/designMobile/white.png');
    height: 305px;
    width: 305px;
    position: relative;
  }

  .img {
    position: absolute;
    top: 50px;
    left: 10px;
    pointer-events: none;
    height: 305px;
    width: 305px;
  }
  .fontSelect {
    height: 20px;
    font-size: 16px;
    font-weight: 500;
    span {
      padding: 0 10px;
    }
    select {
      height: 25px;
    }
  }
  .controls {
    display: flex;
    padding: 10px;
    justify-content: space-between;
    img {
      height: 24px;
      width: 24px;
    }
  }
  .footer {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

@font-face {
  font-family: 'Do Hyeon';
  src: url(https://image.s2bdiy.com/admin/NMpmS2HEZi.ttf);
}
@font-face {
  font-family: 'Fjalla One';

  src: url(https://image.s2bdiy.com/admin/TShNCsaRe6.ttf);
}
@font-face {
  font-family: 'Hanalei Fill';

  src: url(https://image.s2bdiy.com/admin/Bzh4AZnrGt.ttf);
}
@font-face {
  font-family: 'Indie Flower';

  src: url(https://image.s2bdiy.com/admin/8STJfYkXGH.ttf);
}
@font-face {
  font-family: 'Kirang Haerang';

  src: url(https://image.s2bdiy.com/admin/YipTpt7KeA.ttf);
}
/deep/.van-button--primary {
  background-color: #FFA200;
  border: 1px solid #FFA200;
}
</style>
